import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";
import {createApi} from "@reduxjs/toolkit/query/react";

export const resourcesApi = createApi({
    reducerPath: 'resourcesApi',
    tagTypes: ['resources'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getResources: build.query({
            query: (data) => ({
                url: api.resources.getResources(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, ...(Array.isArray(queryArgs?.location_id) ? queryArgs.location_id : [])];
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(
                    ...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id))
                );
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return currentArg !== previousArg;
            },
            providesTags: ['resources']
        }),
        createResource: build.mutation({
            query: (data) => {
                return {
                    url: api.resources.createResource(),
                    method: 'POST',
                    body: data
                }
            },
            async onQueryStarted(newResource, {dispatch, queryFulfilled}) {
                try {
                    const {data} = await queryFulfilled;
                    const changedData = {
                        ...data, ...newResource
                    }
                    dispatch(
                        resourcesApi.util.updateQueryData('getResources', {}, (draft) => {
                            draft.unshift(changedData);
                        })
                    );
                } catch (error) {
                    console.error('Failed to update cache after creating resource:', error);
                }
            }
        }),
        editResource: build.mutation({
            query: ({id, ...data}) => {
                return {
                    url: api.resources.editResource(id),
                    method: 'PUT',
                    body: data
                };
            },
            async onQueryStarted(updatedResource, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled;

                    dispatch(
                        resourcesApi.util.updateQueryData('getResources', {}, (draft) => {
                            const index = draft.findIndex(item => {
                                return item.id === updatedResource.id
                            });

                            if (index !== -1) {
                                draft[index] = {...draft[index], ...updatedResource};
                            }
                        })
                    );
                } catch (error) {
                    console.error('Failed to update cache after editing resource:', error);
                }
            }
        }),
        deleteResource: build.mutation({
            query: ({id}) => ({
                url: api.resources.deleteResource(id),
                method: 'DELETE',
            }),
            async onQueryStarted(deletedResource, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled;
                    dispatch(
                        resourcesApi.util.updateQueryData('getResources', {}, (draft) => {
                            const index = draft.findIndex(item => item.id === deletedResource.id);
                            if (index !== -1) {
                                draft.splice(index, 1);
                            }
                        })
                    );
                } catch (error) {
                    console.error('Failed to update cache after deleting resource:', error);
                }
            }
        }),
    })
});

export const {
    useLazyGetResourcesQuery,
    useCreateResourceMutation,
    useEditResourceMutation,
    useDeleteResourceMutation
} = resourcesApi;